export enum TelematicsManualUpdateType {
  DELEGATION = 'delegation',
  ORDER_POINT_STATUS = 'order-point-status',
  ORDER_STATUS = 'order-status',
  TECHNICAL_POINT_STATUS = 'technical-point-status',
}
